import React from "react";
import { FiMessageCircle, FiCheckCircle, FiFileText } from "react-icons/fi";
import "./AuthCourseSupport.css";

export default function AuthCourseSupport({ brand = "coursepivot" }) {
  return <section id="auth-course-support" className="auth-course-card" data-brand={brand} aria-labelledby="auth-course-title">
    <div className="auth-course-eyebrow"><span className="auth-course-new">NEW</span><span>Course &amp; project support</span></div>
    <h2 id="auth-course-title">One writer. Entire course or project. One conversation.</h2>
    <p className="auth-course-intro">Ongoing help with your course, exam, dissertation or project, all in one place.</p>
    <ul className="auth-course-benefits">
      <li><FiCheckCircle aria-hidden="true" /><div><strong>Follow the progress</strong><p>Share files, receive updates and review each task as it’s delivered.</p></div></li>
      <li><FiMessageCircle aria-hidden="true" /><div><strong>Keep asking</strong><p>Discuss your project and ask follow-up questions at no extra charge.</p></div></li>
      <li><FiFileText aria-hidden="true" /><div><strong>Start with a free quote</strong><p>Unsure of the scope? Pay only for the work you agree on.</p></div></li>
    </ul>
    <p className="auth-course-next">After signing in, select <strong>My Courses</strong> to get started.</p>
    <div className="auth-course-order-benefits"><p>Also included with your orders</p><ul><li>Free Turnitin AI &amp; similarity reports</li><li>Free unlimited revisions</li><li>On-time delivery</li></ul></div>
  </section>;
}
